import React from 'react';

export const DashboardPage: React.FC = () => {
    return <div></div>;
};
